export const TRANSACTION_STATUSES = {
  PROCESSING: 'PROCESSING',
  APPROVED: 'APPROVED',
  APPROVED_PIN: 'APPROVED_PIN',
  APPROVED_SIGNATURE: 'APPROVED_SIGNATURE',
  PARTIAL_APPROVED: 'PARTIAL_APPROVED',
  REFUNDED: 'REFUNDED',
  REVERSED: 'REVERSED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  CANCELLED_BAD_CARD: 'CANCELLED_BAD_CARD',
  CANCELLED_BUSY: 'CANCELLED_BUSY',
  DECLINED: 'DECLINED',
  TIMEOUT: 'TIMEOUT',
}

export enum SWIPER_ERRORS {
  NO_TERMINAL,
  OVER_REFUND,
  INVALID_AMOUNT_INPUT,
  INVALID_NEGATIVE_AMOUNT_INPUT,
  UNAVAILABLE_REVERSAL_STATUS,
  ECONDUIT_ERROR,
  UNKNOWN,
}
